import React from 'react';
import { useTranslation } from 'react-i18next';

import { FaCheck, FaTimes } from 'react-icons/fa';

import MulherApontando from '../assets/img/home/mulher-apontando-h1.png';
import Mulher from '../assets/img/home/mulher.png';
import Otimizacao from '../assets/img/home/otimizacao.png';
import MulherBracosCruzados from '../assets/img/home/mulher-bracos-cruzados.png';
import MulherLoiraApontando from '../assets/img/home/mulher-loira-apontando.png';
import Recrutamento from '../assets/img/home/recrutamento.png';
import Apoio from '../assets/img/home/apoio.png';
import Foco from '../assets/img/home/foco.png';
import Garantia from '../assets/img/home/garantia.png';

const Home = () => {
    const { t } = useTranslation('home');

    return (
        <>
            {/* Seção Principal */}
            <section className="main-title-container container">
                <div className="title-container">
                    <div className="texts">
                        <h1>{t('main_title')} <strong>{t('main_title_strong')}</strong></h1>
                        <p>{t('main_subtitle')}</p>
                    </div>

                    <div className='buttons-cta'>
                        <div className="button-about-us">
                            <button className="call-to-action-btn open-budget-btn">
                                <a href="/cadastro" aria-label={t('btn_hire')}>{t('btn_hire')}</a>
                                <span>&gt;</span>
                            </button>
                        </div>
                    </div>
                </div>
                <div className="img-container">
                    <img src={MulherApontando} alt={t('img_alt_woman_pointing')} draggable="false" />
                </div>
            </section>


            {/* Seção Vantagens */}
            <section className="advantages-container container">
                {[
                    { class: "plus1", title: t('advantages_specialists_title'), text: t('advantages_specialists_text') },
                    { class: "plus2", title: t('advantages_agility_title'), text: t('advantages_agility_text') },
                    { class: "plus3", title: t('advantages_accuracy_title'), text: t('advantages_accuracy_text') }
                ].map((adv, index) => (
                    <div className={`advantage ${index === 1 ? "middle-advantage" : ""}`} key={adv.title}>
                        <div className="plus-container">
                            <span className={adv.class}>+</span>
                        </div>
                        <div className="texts-container">
                            <h2 className="title"><span className={adv.class}>+</span> {adv.title}</h2>
                            <p>{adv.text}</p>
                        </div>
                    </div>
                ))}
            </section>

            {/* Seção Serviços */}
            <section className="service-background">
                <div className="service-container container">
                    <div className="img-container">
                        <img className="boy-img" src={Mulher} alt={t('img_alt_man_pointing')} />
                    </div>
                    <div className="texts-container">
                        <h2>{t('strategic_recruitment_title')}</h2>
                        <p>{t('strategic_recruitment_text_1')}</p>
                        <p>{t('strategic_recruitment_text_2')}</p>

                        <div className="icons-container">
                            <div className="icon">
                                <img width={128} src={Recrutamento} alt="" />
                                <p className='description'>Recrutamento Completo</p>
                            </div>
                            <div className="icon">
                                <img width={128} src={Foco} alt="" />
                                <p className='description'>Apoio de RH Mensal</p>
                            </div>
                            <div className="icon">
                                <img width={128} src={Apoio} alt="" />
                                <p className='description'>Foco em Pessoas, não números</p>
                            </div>
                            <div className="icon">
                                <img width={128} src={Garantia} alt="" />
                                <p className='description'>Garantia de Satisfação</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Seção Negócios */}
            <section className="business-background">
                <div className="business-container container">
                    <div className="texts-container">
                        <h2>{t('business_optimization_title')}</h2>
                        <p>{t('business_optimization_text')}</p>
                    </div>
                    <div className="img-container">
                        <img width={128} src={Otimizacao} alt={t('img_alt_man_graph')} />
                    </div>
                </div>
            </section>

            {/* Seção Sobre Nós */}
            <section className="about-us-background">
                <div className="about-us-container container">
                    <div className="img-container">
                        <img src={MulherBracosCruzados} alt={t('img_alt_woman_crossed_arms')} />
                    </div>
                    <div className="texts-container">
                        <h2>{t('about_us_title')}</h2>
                        <p>{t('about_us_text')}</p>
                    </div>
                    <div className="button-about-us">
                        <button className="call-to-action-about-us">
                            <a href="/sobre" aria-label={t('learn_more_about_us')}>{t('learn_more_about_us')}</a>
                            <span>&gt;</span>
                        </button>
                    </div>
                </div>
            </section>

            {/* Seção Planos */}
            <section className="plans-section container" id="plans-section">
                <div className='container'>
                    <div className="text">
                        <h2 className="title">{t("plans_title")}</h2>
                        <p className="description">
                            {t("plans_description")}
                        </p>
                    </div>

                    <div className='plans-container'>
                        <table className='plans-table'>
                            <thead>
                                <tr>
                                    <th></th> {/* Aqui nao tem que preencher */}
                                    <th>Plano Start</th>
                                    <th>Plano Intermediário</th>
                                    <th>Plano Premium</th>
                                    <th>Vagas Avulsas (Operacional)</th>
                                    <th>Vagas Avulsas (Gerencial)</th>
                                    <th>Vagas Hunter (Tecnologia TI)</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <th scope='row'>Vagas / Mensal</th>
                                    <td>
                                        <FaCheck size={24} color='#2D8ED2' />
                                        2 Operacionais
                                    </td>
                                    <td>
                                        <FaCheck size={24} color='#2D8ED2' />
                                        3 Operacionais
                                    </td>
                                    <td>
                                        <FaCheck size={24} color='#2D8ED2' />
                                        4 Operacionais
                                    </td>
                                    <td><FaTimes size={24} color='#EB1A23' /></td>
                                    <td><FaTimes size={24} color='#EB1A23' /></td>
                                    <td><FaTimes size={24} color='#EB1A23' /></td>
                                </tr>
                                <tr>
                                    <th scope='row'>Testes Técnicos</th>
                                    <td>Básicos</td>
                                    <td>Intermediários</td>
                                    <td>Avançados (DISC, MBTI, Big Five)</td>
                                    <td>Intermediários</td>
                                    <td>Avançados (DISC, MBTI, Big Five)</td>
                                    <td>Avançados (DISC, MBTI, Big Five)</td>
                                </tr>
                                <tr>
                                    <th scope='row'>Background Check</th>
                                    <td><FaTimes size={24} color='#EB1A23' /></td>
                                    <td>Básicos</td>
                                    <td>Completo RH</td>
                                    <td><FaTimes size={24} color='#EB1A23' /></td>
                                    <td><FaTimes size={24} color='#EB1A23' /></td>
                                    <td><FaTimes size={24} color='#EB1A23' /></td>
                                </tr>
                                <tr>
                                    <th scope='row'>Vídeo Pitch</th>
                                    <td><FaTimes size={24} color='#EB1A23' /></td>
                                    <td><FaTimes size={24} color='#EB1A23' /></td>
                                    <td><FaCheck size={24} color='#2D8ED2' /></td>
                                    <td><FaTimes size={24} color='#EB1A23' /></td>
                                    <td><FaCheck size={24} color='#2D8ED2' /></td>
                                    <td><FaCheck size={24} color='#2D8ED2' /></td>
                                </tr>
                                <tr>
                                    <th scope='row'>Consultoria RH</th>
                                    <td><FaTimes size={24} color='#EB1A23' /></td>
                                    <td><FaTimes size={24} color='#EB1A23' /></td>
                                    <td><FaCheck size={24} color='#2D8ED2' /></td>
                                    <td><FaTimes size={24} color='#EB1A23' /></td>
                                    <td><FaTimes size={24} color='#EB1A23' /></td>
                                    <td><FaTimes size={24} color='#EB1A23' /></td>
                                </tr>
                                <tr>
                                    <th scope='row'>Garantia de Substituição</th>
                                    <td><FaCheck size={24} color='#2D8ED2' /> 30 dias</td>
                                    <td><FaCheck size={24} color='#2D8ED2' /> 45 dias</td>
                                    <td><FaCheck size={24} color='#2D8ED2' /> 60 dias</td>
                                    <td><FaCheck size={24} color='#2D8ED2' /> 30 dias</td>
                                    <td><FaCheck size={24} color='#2D8ED2' /> 60 dias</td>
                                    <td><FaCheck size={24} color='#2D8ED2' /> 60 dias</td>
                                </tr>
                                <tr>
                                    <th scope='row'>Pagamento</th>
                                    <td>Contrato Mensal Pós Pago</td>
                                    <td>Contrato Mensal Pós Pago</td>
                                    <td>Contrato Mensal Pós Pago</td>
                                    <td>Pré Pago</td>
                                    <td>Pré Pago</td>
                                    <td>Pré Pago</td>
                                </tr>
                                <tr>
                                    <th scope='row'>Vagas Acumulativas</th>
                                    <td><FaTimes size={24} color='#EB1A23' /></td>
                                    <td><FaTimes size={24} color='#EB1A23' /></td>
                                    <td><FaCheck size={24} color='#2D8ED2' /></td>
                                    <td><FaTimes size={24} color='#EB1A23' /></td>
                                    <td><FaTimes size={24} color='#EB1A23' /></td>
                                    <td><FaTimes size={24} color='#EB1A23' /></td>
                                    </tr>
                            </tbody>
                        </table>

                        <a href="https://api.whatsapp.com/send?phone=5521983372459" target='_blank' className='call-to-action-btn' style={{ textAlign: 'center'}} rel="noreferrer">Contrate Agora</a>
                    </div>
                </div>
            </section>

            {/* Seção Contato */}
            <section className="waiting-contact-background">
                <div className="waiting-contact-container container">
                    <div className="texts-container">
                        <h3>{t('contact_title')}</h3>
                        <p>{t('contact_text')}</p>
                    </div>
                    <div className="img-container">
                        <img className="girl-pointing-img" src={MulherLoiraApontando} alt={t('img_alt_girl_pointing')} draggable="false" />
                        <a className="call-to-action-btn" href="/cadastro" aria-label={t('contact_us')}>{t('contact_us')}</a>
                    </div>
                </div>
            </section>
        </>
    );
};

export default Home;
